import styled from 'styled-components'
import { Grid, Typography } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'

export const StyledBreadcrumbItem = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(15)};
  position: relative;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(18)};
  }
`

export const StyleBreadCrumbLetter = styled.a`
  color: ${props => props.theme.palette.text.secondary};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.secondary.main};
  }

  &.selected {
    font-weight: 500;
    text-decoration: underline;
    color: ${props => props.theme.palette.primary.dark};
  }
`

export const StyledBreadcrumbContainer = styled(Grid)`
  gap: ${props => props.theme.typography.pxToRem(10)};
  padding-top: ${props => props.theme.typography.pxToRem(40)};
  padding-bottom: ${props => props.theme.typography.pxToRem(40)};
  ${props => props.theme.breakpoints.up('sm')} {
    gap: ${props => props.theme.typography.pxToRem(15)};
    padding-bottom: ${props => props.theme.typography.pxToRem(28)};
  }

  > ${StyledBreadcrumbItem}:not(:last-child) {
    &::after {
      content: '\\005c';
      padding-left: ${props => props.theme.typography.pxToRem(10)};
      color: ${props => props.theme.palette.text.secondary};
      ${props => props.theme.breakpoints.up('sm')} {
        padding-left: ${props => props.theme.typography.pxToRem(15)};
      }
    }
  }
`

export const StyledGlossaryCard = styled(Grid)`
  margin-right: 0;
`

export const StyledGlossaryCardWrapper = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: 0;
  }
`

export const StyledGlossaryTitle = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(17)};
  padding: ${props => props.theme.typography.pxToRem(22)} ${props => props.theme.typography.pxToRem(22)};
  font-weight: 500;
  ${props => props.theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.typography.pxToRem(20)} 0;
  }
`

export const StyledGlossaryCardHeading = styled(Typography)`
  margin: 0;
  font-weight: 500;
  padding: ${props => props.theme.typography.pxToRem(16)} 0;
  font-size: ${props => props.theme.typography.pxToRem(18)};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(24)};
  }
`

export const StyledGlossaryHr = styled.div`
  border: solid ${props => props.theme.typography.pxToRem(1)} ${props => alpha(props.theme.palette.text.secondary, 0.19)};
  border-width: ${props => props.theme.typography.pxToRem(3)} 0 0;
  clear: both;
  height: 0;
`

export const StyledGlossaryCardSegment = styled(Grid)`
  position: relative;
  width: 100%;
  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: ${props => props.theme.typography.pxToRem(380)};

    > ${StyledGlossaryCardWrapper}:first-child {
      min-height: ${props => props.theme.typography.pxToRem(342)};
    }
  }
  ${props => props.theme.breakpoints.up('md')} {
    padding-left: ${props => props.theme.typography.pxToRem(390)};
  }
  ${props => props.theme.breakpoints.up('lg')} {
    padding-left: ${props => props.theme.typography.pxToRem(436)};
  }
`

export const StyledGlossaryCardImageContainer = styled.div<{$width: number}>`
  width: ${props => props.theme.typography.pxToRem(props.$width)};
  height: 100%;
  position: relative;
  ${props => props.theme.breakpoints.up('sm')} {
    position: absolute;
    left: 0;
    top: 0;
    width: ${props => props.theme.typography.pxToRem(342)};
    height: ${props => props.theme.typography.pxToRem(342)};
    max-width: ${props => props.theme.typography.pxToRem(342)};
    max-height: ${props => props.theme.typography.pxToRem(342)};
  }
`

export const StyledGlossaryCardImage = styled(Grid)`
  width: 100%;
`

export const StyledGlossaryCardContent = styled(Grid)`
  width: 100%;
  padding: ${props => props.theme.typography.pxToRem(40)} ${props => props.theme.typography.pxToRem(20)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.typography.pxToRem(50)} 0;
  }

  > p {
    margin-bottom: 0;
  }

  > h1 {
    margin-top: 0;
  }
`

export const StyledGlossary = styled.div`
  max-width: ${props => props.theme.typography.pxToRem(1130)};
  margin: auto;
`